// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2204":"0d68f09b","2460":"f5edc3db"}[chunkId] + ".chunk.css";
};